<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Reservation'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" action="#">
          <tidy-row>
            <tidy-select
              [label]="'Property'"
              [items]="addressFilter"
              [multiple]="false"
              [form]="form.get('property')"
              [icon]="'assets/svg/home.svg'"
              [errorMessage]="'Please select a property.'"
              [submitted]="submitted"
              formControlName="property" />
          </tidy-row>
          <tidy-row class="extra-top-padding vertical-align-center">
            <tidy-image [src]="'assets/svg/person-outline.svg'" class="header-size" />
            <tidy-text [header]="'Guest'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [helper]="'Every reservation needs a guest so you can message them and track their stay.'" />
          </tidy-row>
          <tidy-guest-picker
            [submitted]="submitted"
            (valueChange)="onGuestChange($event)" />
          <tidy-row>
            <tidy-datepicker
              label="Check In Date"
              [icon]="'assets/svg/calendar.svg'"
              formControlName="checkInDate"
              [form]="form.controls.checkInDate"
              errorMessage="Please enter a valid date."
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Check In Time'"
              [icon]="'assets/svg/time.svg'"
              [form]="form.controls.checkInTime"
              formControlName="checkInTime"
              [items]="timesItems" />
          </tidy-row>
          <tidy-row>
            <tidy-datepicker
              label="Check Out Date"
              [icon]="'assets/svg/calendar.svg'"
              formControlName="checkOutDate"
              [form]="form.controls.checkOutDate"
              errorMessage="Please enter a valid date."
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Check Out Time'"
              [icon]="'assets/svg/time.svg'"
              [form]="form.controls.checkOutTime"
              formControlName="checkOutTime"
              [items]="timesItems" />
          </tidy-row>
          <tidy-row class="extra-top-padding vertical-align-center">
            <tidy-image [src]="'assets/svg/cash-outline.svg'" class="header-size" />
            <tidy-text [header]="'Price'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [helper]="'What the guest pays for the whole stay. Leave it blank if you are not tracking revenue for this reservation.'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="price"
              [form]="form.controls.price"
              [label]="'Total Price'"
              [icon]="'assets/svg/cash-outline.svg'"
              inputMode="numeric"
              [mask]="'currencyMask'"
              [errorMessage]="'Enter a price of at least $1.00, or leave it blank.'"
              [submitted]="submitted" />
          </tidy-row>

          <tidy-row class="extra-top-padding vertical-align-center">
            <tidy-image [src]="'assets/svg/person-outline.svg'" class="header-size" />
            <tidy-text [header]="'Occupancy'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="guests"
              [form]="form.controls.guests"
              [type]="'number'"
              label="Guests"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="adults"
              [form]="form.controls.adults"
              [type]="'number'"
              label="Adults"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="children"
              [form]="form.controls.children"
              [type]="'number'"
              label="Children"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="infants"
              [form]="form.controls.infants"
              [type]="'number'"
              label="Infants"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="pets"
              [form]="form.controls.pets"
              [type]="'number'"
              label="Pets"
              [icon]="'assets/svg/paw.svg'" />
          </tidy-row>

          <tidy-row style="padding-top: 1rem;">
            <tidy-button
              [text]="'Add Reservation'"
              class="primary"
              [action]="boundAddReservation" />
          </tidy-row>
        </form>
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
